<script>
export default {
  methods: {
    timeFromDateTime: function(dt, includeAmPm=false) {
      const date = new Date(dt);
      const hours = date.getHours();
      const mins = date.getMinutes();
      const hoursStr = (hours === 0) ? '12' : (hours>12) ? (hours-12).toString() : hours.toString();
      const minsStr = (mins === 0) ? '' : `:${mins.toString().padStart(2,'0')}`;
      const amPmStr = (includeAmPm) ? ( hours >= 12 ? 'pm' : 'am' ) : ''

      return `${hoursStr}${minsStr}${amPmStr}`;
    },
    timestampDiffToFuzzyString: function(diff) {
      const mins = Math.floor(diff/(1000*60));
      const hours = Math.floor(mins/60);
      const remainderMins = mins - hours*60;
      
      if(hours > 0) 
      {
        if(remainderMins > 0) {
          return `over ${(hours===1) ? '1 hour' : hours+' hours'}`;
        } else {
          return (hours===1) ? '1 hour' : hours+' hours';
        }
      } else if(remainderMins > 0) {
        return (remainderMins===1) ? '1 minute' : remainderMins+' minutes';
      } else {
        return 'a few more seconds';
      }
    },
    timestampDiffToPreciseString: function(diff) {
      const mins = Math.floor(diff/(1000*60));
      const hours = Math.floor(mins/60);
      const remainderMins = mins - hours*60;
      
      return `${(hours>0)?hours+'h ':''}${(remainderMins>0)?remainderMins+'m':''}`
    },       
  }
}
</script>